import { Link } from "react-router";
import styles from "../../styles/common/sticky_cta.module.css";
import { ReactComponent as Dots } from "../../assets/training/dots.svg";
import { ReactComponent as Arrow } from "../../assets/evidence/arrow.svg";
import { ReactComponent as Lines } from "../../assets/curriculum/lines.svg";
import { ReactComponent as Delta } from "../../assets/spaces/delta.svg";
import Shikshagraha from "../../assets/programs/shikshagraha_logo.png";
import MGFellowship from "../../assets/programs/mg_fellowship_logo.svg";

const StickyCTA = ({
  page,
  ctaText,
  mobileCtaText = ctaText,
  bgColor,
  iconColor,
  iconHoverColor,
  textColor,
  textBgColor,
  textHoverBgColor,
  textHoverColor = textColor,
  showShadow = true,
  ctaLink = "/get-involved/partner",
  mobileCtaLink = ctaLink,
  target = "_blank",
}) => {
  return (
    <>
      <div className={styles.stickyCTAContainer}>
        <Link
          to={ctaLink}
          target={target}
          className={styles.stickyOption}
          style={{
            "--icon-bg": `var(${iconColor})`,
            "--icon-hover-bg": `var(${iconHoverColor})`,
          }}
        >
          {page === "training" && <Dots className={styles.dots} />}
          {page === "evidence" && <Arrow className={styles.arrow} />}
          {page === "curriculum" && <Lines className={styles.lines} />}
          {page === "makerspace" && <Delta className={styles.delta} />}
          {page === "shikshagraha" && (
            <img src={Shikshagraha} alt="Shikshagraha" />
          )}
          {page === "mg-fellowship" && (
            <img
              src={MGFellowship}
              alt="MG Fellowship"
              className={styles.mgFellowshipLogo}
            />
          )}
          {ctaText && (
            <div
              className={`${styles.supportButton} shadow`}
              style={{
                "--text-bg": `var(${textBgColor})`,
                "--text-color": `var(${textColor})`,
                "--text-hover-bg": `var(${textHoverBgColor})`,
                "--text-hover-color": `var(${textHoverColor})`,
              }}
            >
              {ctaText}
            </div>
          )}
        </Link>
        <div
          className={`${styles.background} ${showShadow ? styles.backgroundShadowHover : ""}`}
          style={{
            backgroundColor: `var(${bgColor})`,
          }}
        ></div>
      </div>
      {mobileCtaText && (
        <Link
          to={mobileCtaLink}
          target={target}
          className={styles.supportButtonMobile}
        >
          {mobileCtaText}
        </Link>
      )}
    </>
  );
};

export default StickyCTA;
